import React from 'react';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, CHECKOUT_URL, PACK_IMAGE, PRICE, PRODUCT_NAME } from '../data/content';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="scroll-mt-2 border-y-4 border-brand-red bg-brand-yellow" data-id="element-118" data-mp="ddvgdgeskhf3">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-119" data-mp="icor512p1ubk">
        <p className="text-xs font-semibold uppercase tracking-widest text-brand-ink" data-id="element-120" data-mp="me1xrddm21jj">
          Oferta especial — Sistema completo 6 en 1
        </p>
        <h2 id="oferta-titulo" className="mt-2 font-display text-2xl font-bold leading-tight text-brand-blue sm:text-3xl" data-id="element-121" data-mp="rc3ie2qoq8x4">
          Comenzá hoy a organizar tus clases y avanzá a tu ritmo.
        </h2>

        <Reveal className="mt-3 overflow-hidden rounded-2xl border-4 border-dashed border-brand-blue bg-white text-brand-ink" data-id="element-122" data-mp="2y3ul7h0jiadh">
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block" data-id="element-123" data-mp="12oa9kycxqdkt">
            <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos`} className="block w-full" data-id="element-124" data-mp="sxp3kpuxm6rv" />
          </a>
          <div className="p-3" data-id="element-125" data-mp="1lme52pzwge45">
            <p className="font-display text-base font-bold uppercase leading-tight text-brand-blue" data-id="element-126" data-mp="1lmmkaojhvvii">
              {PRODUCT_NAME}
            </p>
            <p className="mt-0.5 font-display text-2xl font-bold uppercase tracking-wide" data-id="element-127" data-mp="1gl6xaqxrbexh">
              6 Tomos + 5 Bonos
            </p>
            <p className="text-xs text-brand-muted sm:text-sm" data-id="element-128" data-mp="17n4p9rflvm0p">
              🎁 Bonos valorados en{' '}
              <span className="font-bold text-brand-red line-through" data-id="element-129" data-mp="172hvg5nkfbv">
                {BONUS_VALUE}
              </span>
            </p>

            <p className="mt-1.5 inline-block rounded-md bg-brand-yellow px-2.5 py-0.5 text-xs font-bold uppercase tracking-wide text-brand-ink" data-id="element-130" data-mp="3sb9ach1tjswl">
              🔥 Oferta especial
            </p>

            <p className="mt-1 font-display text-5xl font-bold leading-none tracking-tight text-brand-red sm:text-6xl" data-id="element-131" data-mp="2n6hyfl9t57j">
              <span className="text-3xl text-brand-blue sm:text-4xl" data-id="element-132" data-mp="3kve0loaldpba">Hoy:</span>{' '}
              {PRICE}
            </p>
            <p className="mt-1 text-xs font-semibold text-brand-muted" data-id="element-133" data-mp="3b3hzs5h4fl3d">
              Pago único • Sin mensualidades • Acceso Digital
            </p>

            <CtaButton href={CHECKOUT_URL} external size="lg" className="mt-3" data-id="element-134" data-mp="3fvt1ndvf9gyk">
              🚀 Sí, quiero el sistema completo por {PRICE}
            </CtaButton>

            <p className="mt-2.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-xs font-semibold text-brand-muted" data-id="element-135" data-mp="363vpo4wlakys">
              <span className="flex items-center gap-1" data-id="element-136" data-mp="2s55syqdomnay">
                <ZapIcon size={12} className="text-brand-blue" data-id="element-137" data-mp="2x48lxcge132k" />
                Acceso Inmediato
              </span>
              <span className="text-brand-muted/50" data-id="element-138" data-mp="2dj019cfd9i4v">•</span>
              <span className="flex items-center gap-1" data-id="element-139" data-mp="28iu5bk22d9gz">
                <ShieldCheckIcon size={12} className="text-brand-green" data-id="element-140" data-mp="28kezv9odoseu" />
                Garantía de 7 Días
              </span>
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}